import { app } from '../../app.module'
/**
 * キーワード検索フォーム
 * @class KeywordSearchCtrl
 */
class KeywordSearchCtrl {
  private keyword: string
  private label: string
  private onChange: Function

  /**
   * 初期化イベント
   */
  public $onInit() {
    if (!this.label) {
      this.label = 'キーワード検索'
    }
    // キーワード検索をしている場合は、キーワード検索を変更する
    if (this.keyword) {
      this.changeKeyword()
    }
  }

  /**
   * キーワード検索の変更
   */
  public changeKeyword() {
    if (typeof this.onChange === 'function') {
      this.onChange({ keyword: this.keyword })
    }
  }
}

/**
 * キーワード検索フォーム
 * attr: {string} keyword 選択しているキーワード検索
 * attr: {function} onChange キーワード検索の変更イベント
 */
app.component('keywordSearchForm', {
  bindings: {
    keyword: '<',
    label: '@',
    onChange: '&',
  },
  template: require('./keyword-search-form.pug')(),
  controller: KeywordSearchCtrl,
})
